import { faLink } from '@fortawesome/pro-regular-svg-icons'
import { Button, Box, Text, Flex, type BoxProps, Card } from '@mantine/core'

import { useQueryGetUserLogged, useQueryGetAllIdentities } from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { useLinkAccount } from '../../hooks/useLinkAccount'
import { RowIdentity } from './RowIdentity'
import styles from './styles.module.css'

export function CardIdentities(props: BoxProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_account' })
  const { data, isFetching: isIdentitiesLoading } = useQueryGetAllIdentities()
  const { data: user, isFetching: isUserLoading } = useQueryGetUserLogged()
  const { linkAccount, isSyncLoading, syncAccounts } = useLinkAccount()
  const loading = isIdentitiesLoading || isUserLoading || isSyncLoading

  return (
    <Card {...props} className={styles.cardIdentities}>
      <Box className={styles.cardIdentitiesHeader}>
        <Icon
          icon={faLink}
          withCircleBackground
          w={40}
          h={40}
          style={{ gridArea: 'icon' }}
        />
        <Box style={{ gridArea: 'title' }}>
          <Text fw={500}>{t('card_linked_accounts.title')}</Text>
          <Text c='dimmed'>{t('card_linked_accounts.description')}</Text>
        </Box>
        <Flex gap='sm' style={{ gridArea: 'buttons' }}>
          <Button variant='outline' onClick={linkAccount} size='sm'>
            {t('card_linked_accounts.button_link')}
          </Button>
          <Button size='sm' variant='outline' onClick={() => syncAccounts()}>
            {t('card_linked_accounts.button_sync')}
          </Button>
        </Flex>
      </Box>
      <Box className={styles.cardIdentitiesContent}>
        {data?.user_identity?.map((identity) => (
          <RowIdentity
            key={identity.auth0_id}
            loading={loading}
            identity={identity}
            is_main={user?.auth0_id === identity.auth0_id}
          />
        ))}
      </Box>
    </Card>
  )
}
